export * from './format';
export function areAllElementsIn(arr1, arr2) {
    return arr1.every(item => arr2.includes(item));
}
;
